
    import { Component, Vue } from "vue-property-decorator";
    import { Dialog, Toast } from "vant";
    import { locale } from "dayjs";
    import UAgreement from "../../agreement.vue";
    import UPrivacy from "../../privacy.vue";
    import UAuthorization from "../../authorization.vue";
    import RightsAgreement from "../../rights-agreement.vue";
    import RightsPrivacy from "../../rights-privacy.vue";
    import globalConfig from "src/config/index";
    const showRightsCode = globalConfig.showRightsCode;
    
    @Component({
        components:
        {
            UPrivacy,
            UAgreement,
            RightsAgreement,
            RightsPrivacy,
            UAuthorization
        }
    })
    export default class Privacy extends Vue
    {

        /**
         * 是否显示服务协议
         * @private
         * @returns boolean
         */
        private showAgreement: boolean = false;

        /**
         * 是否显示隐私协议
         * @private
         * @returns boolean
         */
        private showPrivacy: boolean = false;

        /* 关闭用户授权协议
        * @private
        * @returns void
        */
        private closeAuthorization() {
            this.showAuthorization = false
        }

        /**
         * 是否显示权益隐私协议
         * @private
         * @returns boolean
         */
        private showRightsAgreement: boolean = false;

        /**
         * 是否显示服务协议
         * @private
         * @returns boolean
         */
         private showAuthorization: boolean = false;

        /**
         * 是否显示权益隐私协议
         * @private
         * @returns boolean
         */
        private showRightsPrivacy: boolean = false;


        /**
         * 获取当前登入信息
         * @private
         * @returns void
         */
        private get showRights(): any
        {
            return showRightsCode.includes(localStorage.getItem("appid"));
        }

        /**
         * 打开隐私协议
         * @private
         * @returns void
         */
        private onPrivacy(): void
        {
            if(this.showRights)
            {
                this.showRightsPrivacy = true;
            }
            else
            {
                this.showPrivacy = true;
            }
        }

        /**
         * 打开服务协议
         * @private
         * @returns void
         */
        private onAgreement(): void
        {
            if(this.showRights)
            {
                this.showRightsAgreement = true;
            }
            else
            {
                this.showAgreement = true;
            }
        }

        /* 跳转携保隐私
        * @private
        * @returns void
        */
        private closeRightsPrivacy(): void
        {
            this.showRightsPrivacy = false;
        }

        /* 关闭携保权益协议
        * @private
        * @returns void
        */
        private closeRightsAgreement(): void
        {
            this.showRightsAgreement = false;
        }

        /* 关闭用户协议
        * @private
        * @returns void
        */
        private closeAgreement(): void
        {
            this.showAgreement = false;
        }

        /* 关闭隐私协议
        * @private
        * @returns void
        */
        private closePrivacy(): void
        {
            this.showPrivacy = false;
        }

        /**
         * 是否显示权益服务协议
         * @private
         * @returns boolean
         */
         private showRightsAuthorization: boolean = false;

        /**
         * 用户授权协议
         * @private
         * @returns void
         */
         private onAuthorization(): void {
            if(this.showRights)
            {
                this.showRightsAuthorization = true;
            }
            else
            {
                this.showAuthorization = true;
            }
        }
        
    }
    